/**
 * @voltxampere/ui — 74HC74 dual D-flop CMOS variant (Sprint 42-1, sequential placeholder)
 *
 * PLACEHOLDER per ADR-0061 §"MVP DC-only scope". Same placeholder
 * semantics as the Sprint 41-4 7474 — drag-drop and schema
 * persistence work, but DC simulate returns vLow until the future
 * Transient State Machine sprint ships per-component state and
 * clock-edge detection.
 *
 * Reference: TI SN74HC74. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic74hc74 = {
    id: "74hc74",
    nameTr: "74HC74 (Çift D Flip-Flop CMOS, DIP-14, placeholder)",
    nameEn: "74HC74 (Dual D Flip-Flop CMOS, DIP-14, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "74HC74",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "D-FLOP",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 25e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-74hc74.js.map